import { List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { NavLink } from "react-router-dom";

const FolderListBase = ({
    items,
    selectedItemId = null,
    selectedItemIds = [],
    onItemClick = null,
    getItemLink = null,
}) => {
    return (
        <List id="folder-list" sx={{ overflowY: 'auto', maxHeight: '300px', maxWidth: '300px', width: '100%' }}>
            {items.map((item) => {
                const isSelected = selectedItemId === item.id || selectedItemIds.includes(item.id);

                const content = ({ isActive = false } = {}) => (
                    <ListItemButton
                        selected={isActive || isSelected}
                        onClick={onItemClick ? () => onItemClick(item) : undefined}
                        sx={{
                            '&.Mui-selected': {
                                backgroundColor: 'rgba(0, 0, 0, 0.12)',
                            },
                            '&.Mui-selected:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.18)',
                            }
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: '40px' }}>
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText
                            primary={item.title}
                            sx={{
                                color: 'black',
                                fontWeight: (isActive || isSelected) ? 'bold' : 'normal'
                            }}
                        />
                    </ListItemButton>
                );

                const link = getItemLink ? getItemLink(item) : null;

                return (
                    <ListItem key={item.id} disablePadding>
                        {link ? (
                            <NavLink
                                to={link}
                                style={{
                                    textDecoration: 'none',
                                    display: 'block',
                                    width: '100%'
                                }}
                            >
                                {({ isActive }) => content({ isActive })}
                            </NavLink>
                        ) : (
                            content()
                        )}
                    </ListItem>
                );
            })}
        </List>
    );
};

export default FolderListBase;
